import $ from "jquery";
// Här anropas alla funktioner som ska köras vid DOM-ready

$(function () {
    far.alerts.initialize();
    far.buttonAriaState.initialize();
    far.input.initialize();
    far.lazyContent.initialize();
    far.showmore.initialize();
    far.toggle.initialize();
    far.datepicker.initialize();

    if (document.querySelector(".gdpr-initialize--hidden")) {
        far.gdpr.initialize();
    }

    // Kör alla anrop som registrerats före jQuery laddats
    if (typeof (window.q) !== 'undefined') {
        $.each(q, function (index, f) { f(); });
    }
});
